import { DetailsRow } from "./Details";
import { DisplayMode, PropertyImage, SortMode } from "./types";
import { SavedRow, } from "./types";
import { PropertySource } from "./lib/property-api";
import { toS3Image as toS3Image_impl} from "./toS3Image";

export const dd = console.debug;

export function make_property_id(id: string) : string {
  if(typeof id === 'undefined'){
    throw new Error('make_property_id got undefined value');
  }
  if(id.match(/^key/i)){
    return id.replace(/^key/i,'');
  }
  return id;
}
export function formatPrice(price: number): string {
  if(typeof price === 'undefined' || price === null){
    return '';
  }
  // Use toLocaleString to add commas and format the number
  const formattedPrice = price.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formattedPrice;
}
export function toS3Image(img: string|URL, order: number,source: PropertySource): PropertyImage {
  return toS3Image_impl(img,order,source);
}
/**
 * Lazy hack
 */
export function formatDecimalNumber(price: number): string {
  return formatPrice(price).replace("$", "");
}

export function calculatePriceIncrease(
  price: number,
  oldPrice: number
): number {
  return price - oldPrice;
}

export function conditionalAdd(
  data: any,
  key: string,
  label: string | number,
  to: Array<DetailsRow>
) {
  if (typeof data[key] !== "undefined" && data[key] !== null) {
    if (Array.isArray(data[key])){
      to.push({
        label: typeof label === "number" ? key : label,
        value: data[key],
      });
      return;
    }
    if (String(data[key]).length > 0 && String(data[key]) !== "-1") {
      to.push({
        label: typeof label === "number" ? key : label,
        value: data[key],
      });
    }
  }
}
export function conditionalAddPositiveNumber(
  data: any,
  key: string,
  label: string | number,
  to: Array<DetailsRow>
) {
  if (typeof data[key] !== "undefined") {
    if (Number(data[key]) <= 0) {
      return;
    }
    to.push({
      label: typeof label === "number" ? key : label,
      value: data[key],
    });
  }
}
export function conditionalAddIfTrue(
  data: any,
  key: string,
  label: string | number,
  to: Array<DetailsRow>
) {
  if (typeof data[key] !== "undefined" && data[key] === true) {
    to.push({
      label: typeof label === "number" ? key : label,
      value: data[key],
    });
  }
}
export function getListingFromURL(): string | null {
  const page_url: URL = new URL(window.location.href);
  const params: URLSearchParams = page_url.searchParams;
  return params.get("listing");
}
export function getDisplayModeFromURL(): DisplayMode | null {
  const page_url: URL = new URL(window.location.href);
  const params: URLSearchParams = page_url.searchParams;
  const value: string | null = params.get("displayMode");
  if (!value) {
    return null;
  }
  switch (value) {
    case "show-all":
    case "show-sold":
    case "show-active":
    case "property":
      return value;
    default:
      return null;
  }
}
export function getSortFromURL(): SortMode {
  const page_url: URL = new URL(window.location.href);
  const params: URLSearchParams = page_url.searchParams;
  const value: string | null = params.get("sortMode");
  switch (value) {
    case "newest":
    case "highest-first":
    case "lowest-first":
      return value;
    default:
      return 'newest';
  }
}
export function createGoogleMapsLink(data: SavedRow) : URL {
  const u: URL = new URL('https://www.google.com/');
  u.pathname += '/maps/place/' + encodeURIComponent(
    `${data.StreetNumber} ${data.StreetName} ${data.StreetSuffix} ${data.PostalCity}, ${data.StateOrProvince} ${data.PostalCode}`
  );
  return u;
}
export function getSinglePropertyShareLinkFromURL(): number|undefined {
  const page_url: URL = new URL(window.location.href);
  const params: URLSearchParams = page_url.searchParams;
  const value: string | null = params.get("share-property");
  if(value && !isNaN(Number(value))){
    return Number(value);
  }
}

export function getShareLinkFromURL(): number|undefined {
  const page_url: URL = new URL(window.location.href);
  const params: URLSearchParams = page_url.searchParams;
  const value: string | null = params.get("share");
  if(value && !isNaN(Number(value))){
    return Number(value);
  }
}

export function getEnvironment() : string {
  const u: URL = new URL(window.location.href);
  if(u.pathname.match(/^\/staging\//)){
    return 'staging';
  }
  if(u.hostname === 'localhost'){
    return 'dev';
  }
  if(u.hostname === 'lombardohomesandestates.com'){
    return 'prod';
  }
  return 'prod';
}
